<template lang="html">
  <si-container
    :back="true"
    @back="goBack"
  >
    <v-flex
      xs12
      sm5
    >
      <v-layout wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="">
              <div class="">
                <div class="">
                  {{ identity.name }}
                </div>
                <div class="body-2 grey--text">
                  {{ identity.email || identity.id }}
                </div>
              </div>
            </v-card-title>
            <v-container pa-4>
              <v-layout wrap>
                <v-flex xs12>
                  <div class="caption grey--text">
                    Last interaction
                  </div>
                  <div>{{ _formatDateTime(identity.last) }} - <i>{{ _timeAgo(identity.last) }}</i> </div>
                </v-flex>
                <v-flex
                  xs12
                  class="body-2"
                >
                  <div class="caption grey--text">
                    Purchases
                  </div>
                  <template v-for="(count, statId) in userPurchases">
                    <v-flex
                      :key="statId"
                      xs12
                      px-0
                    >
                      <v-layout
                        align-center
                        ma-0
                      >
                        <v-icon
                          v-if="statId === '_assistance'"
                          left
                        >
                          face
                        </v-icon>
                        <v-icon
                          v-else
                          left
                        >
                          assessment
                        </v-icon>
                        <span class="font-weight-bold mr-2">{{ count }}</span> {{ calculatorVairantName(statId) }}
                      </v-layout>
                    </v-flex>
                  </template>
                </v-flex>
                <v-flex
                  xs12
                  class=""
                >
                  <div class="caption grey--text">
                    Total Revenue
                  </div>
                  <v-flex
                    xs12
                    px-0
                  >
                    {{ _$(userStats._revenue || 0) }}
                  </v-flex>
                </v-flex>
                <v-flex
                  xs12
                  class="body-2"
                >
                  <div class="caption grey--text">
                    Locations
                  </div>
                  <v-flex
                    xs12
                    px-0
                  >
                    <template v-for="(location, i) in locations">
                      <div :key="i">
                        <v-icon left>
                          location_on
                        </v-icon>{{ location.city }}, {{ location.state }} {{ location.postal }}, {{ location.country_name }}
                      </div>
                    </template>
                  </v-flex>
                </v-flex>
                <v-flex
                  xs12
                  class="body-2"
                >
                  <div class="caption grey--text">
                    Tags
                  </div>
                  <v-chip-group
                    multiple
                    column
                  >
                    <v-chip
                      v-for="tag in tags"
                      :key="tag"
                    >
                      {{ tag }}
                    </v-chip>
                  </v-chip-group>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-responsive :aspect-ratio="1">
              <!-- <googlemaps-map
              :center.sync="center"
              :zoom.sync="zoom"
              style="height:100%"
              @idle="onIdle"
              />
              <googlemaps-marker
                v-for="marker in markers"
                :key="marker.id"
                :position="marker.position"
              />
              </googlemaps-map> -->
              <GmapMap
                ref="map"
                :center="center"
                :zoom="zoom"
                style="height:100%"
                @idle="onIdle"
              >
                <GmapMarker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @click="center = m.position"
                />
              </GmapMap>
            </v-responsive>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-container pa-4>
              <v-layout wrap>
                <v-flex
                  xs12
                  class="body-2"
                >
                  <div class="caption grey--text">
                    Fingerprints
                  </div>
                  <div
                    v-for="fingerprint in _sortObject(fingerprints, 'last').reverse()"
                    :key="fingerprint.id"
                  >
                    <v-flex
                      :key="`1${fingerprint.id}`"
                      xs12
                      px-0
                    >
                      <v-layout
                        align-center
                        ma-0
                        class="font-weight-bold"
                      >
                        <v-icon left>
                          {{ (fingerprint.device || {}).isMobile ? 'smartphone' : 'desktop_windows' }}
                        </v-icon>
                        {{ (fingerprint.device || {}).os }} {{ (fingerprint.device || {}).osVersion }} | {{ (fingerprint.device || {}).browser }} {{ (fingerprint.device || {}).browserVersion }}
                      </v-layout>
                    </v-flex>
                    <v-layout
                      :key="`2${fingerprint.id}`"
                      wrap
                      ml-5
                      mb-2
                    >
                      <v-flex xs12>
                        <v-layout
                          align-center
                          ma-0
                        >
                          <v-icon
                            small
                            left
                          >
                            access_time
                          </v-icon> {{ _formatDateTime(fingerprint.last) }}
                        </v-layout>
                      </v-flex>
                      <!-- <v-divider vertical class="mx-3"></v-divider> -->
                      <v-flex xs12>
                        <v-layout
                          align-center
                          ma-0
                        >
                          <v-icon
                            small
                            left
                          >
                            mouse
                          </v-icon> {{ fingerprint.cnt }}
                        </v-layout>
                      </v-flex>
                      <!-- <v-divider vertical class="mx-3"></v-divider> -->
                      <v-flex xs12>
                        <v-layout
                          align-center
                          ma-0
                        >
                          <v-icon
                            small
                            left
                          >
                            fingerprint
                          </v-icon>
                          <span class="font-weight-boldx">{{ fingerprint.id }}</span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex
      xs12
      sm7
    >
      <v-layout
        wrap
        justify-center
      >
        <v-flex xs12>
          <v-select
            v-model="selectedTypes"
            :items="interactionTypesSorted"
            label="Show Interactions"
            multiple
            outlined
            hide-details
            solo
            flat
          >
            <template #selection="{ index }">
              <span v-if="index === 0">Showing <strong>{{ selectedTypes.length === interactionTypesSorted.length ? 'ALL' : selectedTypes.length }}</strong> Type(s)</span>
            </template>
            <template #prepend-item>
              <v-list-item
                ripple
                @click="toggle"
              >
                <v-list-item-action>
                  <v-icon :color="selectedTypes.length > 0 ? 'primary' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-timeline align-topx>
        <v-slide-y-transition group>
          <v-timeline-item
            v-for="interaction in interactions"
            :key="interaction.id"
            fill-dot
            small
            :left="!type(interaction.i).primary"
            :right="type(interaction.i).primary"
            :color="type(interaction.i).color"
            :icon="type(interaction.i).icon"
          >
            <v-layout ma-0>
              <v-flex
                pa-0
                :text-right="!type(interaction.i).primary"
              >
                <v-layout
                  ma-0
                  align-center
                  :justify-end="!type(interaction.i).primary"
                >
                  <strong>{{ type(interaction.i).name }}</strong>
                  <v-tooltip
                    v-if="interactionHasClick(interaction)"
                    bottom
                  >
                    <template #activator="{on}">
                      <v-btn
                        small
                        icon
                        color="primary"
                        class="ml-2"
                        v-on="on"
                        @click="interactionClick(interaction)"
                      >
                        <v-icon>launch</v-icon>
                      </v-btn>
                    </template>
                    View
                  </v-tooltip>
                </v-layout>
                <div class="caption grey--text">
                  {{ _formatDateTime(interaction.ts) }}
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-slide-y-transition>
      </v-timeline>
    </v-flex>
  </si-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach, sortBy, cloneDeep } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'

export default {
  mixins: [ helpers, binder ],
  props: {
    identities: Object
    // type: String
  },
  data () {
    return {
      fingerprintInteractions: {},
      fingerprints: {},
      interactionTypes: {},
      interactionDisplay: {},
      selectedTypes: [],
      userStats: {},
      defaultCenter: { lat: -28.06882930390813, lng: 133.95069923085435 },
      center: { lat: -28.06882930390813, lng: 133.95069923085435 },
      zoom: 4,
      currentmarker: null,
      boundsSet: false,
      resetZoom: false,
      map: null
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    markers () {
      let markers = []
      forEach(this.fingerprints, fp => {
        forEach(fp.locations, (l, id) => {
          markers.push({
            id: id,
            position: { lat: l.latitude, lng: l.longitude }
            // text: `${l.city}, ${l.state} ${l.postal}`
          })
        })
      })
      return markers
    },
    identityType () {
      return this.$route.params.sub
    },
    identityId () {
      return this.$route.params.id
    },
    identity () {
      return this.identities[this.identityId] || {}
    },
    interactions () {
      var arr = []
      forEach(this.fingerprintInteractions, fp => {
        arr = arr.concat(this._sortObject(fp))
      })
      arr = arr.filter(i => this.selectedTypes.includes(i.i))
      return sortBy(arr, 'ts').reverse()
    },
    interactionTypesSorted () {
      return Object.keys(this.interactionTypes).map(id => { return { text: this.type(id).name, value: id, primary: this.type(id).primary || false } })
    },
    showAll () {
      return this.interactionTypesSorted.length === this.selectedTypes.length
    },
    showSome () {
      return this.selectedTypes.length > 0 && !this.showAll
    },
    icon () {
      if (this.showAll) return 'check_box'
      if (this.showSome) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
    locations () {
      let locations = {}
      forEach(this.fingerprints, fp => {
        forEach(fp.locations, (location, id) => {
          locations[id] = location
        })
      })
      return locations
    },
    tags () {
      let tags = []
      forEach(this.fingerprints, fp => {
        forEach(fp.tags, tag => {
          tags.push(tag)
        })
      })
      return [...new Set(tags)]
    },
    userPurchases () {
      let purchases = cloneDeep(this.userStats)
      delete purchases._revenue
      delete purchases._total
      return purchases
    }
  },
  watch: {
    '$route.params.sub' (v) {
      this.fingerprints = {}
      this.fingerprintInteractions = {}
      this.resetMap()
      this.$nextTick(() => {
        if (v) {
          this.bindIdentity()
        } else {
          this.$unbindAll()
        }
      })
    },
    interactionTypesSorted () {
      this.selectedTypes = this.interactionTypesSorted.filter(i => i.primary).map(t => t.value)
    },
    markers () {
      this.setBounds()
    }
  },
  beforeMount () {
    this.bindIdentity()
  },
  methods: {
    bindIdentity () {
      // this.$unbindAll()
      // this.$bindxxx(rtdb.ref(`stats/clients/${this.identityId}`), 'userStats')
      // this.$bindxxx(rtdb.ref(`clientPath/_indexInteractions`), 'interactionTypes')
      // this.$bindxxx(rtdb.ref(`clientPath/_mappingTypes`), 'interactionDisplay')
      this.$bindRtdb('userStats', `stats/clients/${this.identityId}`)
      this.$bindRtdb('interactionTypes', `clientPath/_indexInteractions`)
      this.$bindRtdb('interactionDisplay', `clientPath/_mappingTypes`)

      if (this.identityType === 'identity') {
        rtdb.ref(`clientPath/identities/${this.identityId}`).once('value', s => {
          let identity = s.val()
          for (var fp in identity.fingerprints) {
            const fpId = fp
            rtdb.ref(`clientPath/interactions/${fpId}`)
                .once('value')
                .then(s => { this.$set(this.fingerprintInteractions, fpId, s.val()) })
            rtdb.ref(`clientPath/fingerprints/${fpId}`)
                .once('value')
                .then(s => { this.$set(this.fingerprints, fpId, s.val()) })
          }
        })
      } else {
        rtdb.ref(`clientPath/interactions/${this.identityId}`)
            .once('value')
            .then(s => { this.$set(this.fingerprintInteractions, this.identityId, s.val()) })
        rtdb.ref(`clientPath/fingerprints/${this.identityId}`)
            .once('value')
            .then(s => { this.$set(this.fingerprints, this.identityId, s.val()) })

        // rtdb.ref(`clientPath/_indexFingerprints/${this.identityId}`).once('value', s => { if (s.val()) this.$set(this.fingerprints, this.identityId, s.val()) })
      }
    },
    calculatorVairantName (statId = '') {
      if (statId === '_assistance') return 'Super Info Assist'
      let [calculatorId, variantId] = statId.split('_') || []
      let variants = (this._calculators[calculatorId] || {}).variants || {}
      return (variants[variantId] || {}).name || ''
    },
    type (typeName) {
      let type = this.interactionDisplay[typeName] || {}
      let defaultType = {
        icon: 'mouse',
        color: 'grey',
        name: typeName
      }
      return Object.assign({}, defaultType, type)
    },
    closeMe () {
      this.$emit('close')
    },
    toggle () {
      this.$nextTick(() => {
        if (this.showAll) {
          this.selectedTypes = []
        } else {
          this.selectedTypes = this.interactionTypesSorted.map(t => t.value)
        }
      })
    },
    goBack () {
      if (this.$route.query.back) {
        this.$router.replace(this.$route.query.back)
      } else {
        this.$router.replace(`/clientpath`)
      }
    },
    resetMap () {
      this.boundsSet = false
      this.zoom = 4
      this.center = this.defaultCenter
    },
    setBounds () {
      if (this.markers.length === 0) return this.resetMap
      var bounds = new google.maps.LatLngBounds() // eslint-disable-line no-undef
      forEach(this.markers, marker => {
        bounds.extend(marker.position)
      })
      this.$refs.map.$mapPromise.then((map) => {
        map.fitBounds(bounds)
      })
      this.boundsSet = true
      this.resetZoom = true
    },
    interactionClick ({ i:type, meta = {} }) {
      console.log(type, meta);
      if (type && type.includes('purchase_calc_')) this.$router.push(`/calculations/${meta.calculatorId}/${meta.calculationId}`)
      if (type && type.includes('purchase_assistance')) this.$router.push(`/assistance/${meta.id}`)
      if (type && type.includes('feedback')) this.$router.push(`/feedback/${meta.id}`)
      if (type && type.includes('view_report_')) this.$router.push(`/calculations/${meta.calculatorId}/${meta.calculationId}`)

    },
    interactionHasClick ({ i:type }) {
      let enabledFor = [ 'purchase_calc_', 'purchase_assistance', 'feedback', 'view_report_' ]
      return enabledFor.map(id => type ? type.includes(id) : false).some(v => v)
    },
    onIdle () {
      if (!this.boundsSet) {
        this.setBounds()
      }
      if (this.resetZoom) {
        this.resetZoom = false
        this.zoom = 6
      }
    }
  }
}
</script>

<style lang="css">
.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}
</style>
